import go from '@/gojs/go'
import micro from '@/sui/data/microOrgs'
import assert from '@/sui/tools/assert'

const resistancesIndexAndCode = [
  { index: 0, code: 'S' },
  { index: 1, code: 'R' },
  { index: 9, code: 'NC' }
]

const resistancesList = (function () {
  function item (n, v, l, t, f = null) {
    assert.notNull(n)
    assert.notNull(v)
    assert.notNull(l)
    assert.notNull(t)

    return {
      n: n,
      v: v,
      l: l,
      t: t,
      f: f
    }
  }

  return [
    item(
      'oxa', 0, resistancesIndexAndCode,
      'Résistance à la méticilline', go.mo.sarm
    ),
    item(
      'c3g', 1, resistancesIndexAndCode,
      'Résistance aux céphalosporines de 3ème génération',
      go.mo.sirn
    ),
    item(
      'flu', 2, micro.fluList, 'Résistance au fluconazole'
    ),
    item(
      `gly`, 3, resistancesIndexAndCode,
      'Résistance aux glycopeptides',
      go.mo.sirn
    ),
    item(
      `car`, 4, resistancesIndexAndCode,
      'Résistance aux carbapénèmes',
      go.mo.sirn
    ),
    item(
      `pan`, 5, micro.panList.v2, 'Résistance PAN'
    ),
    item(
      `rktg`, 6, micro.rktgList, 'Résistance KTG'
    ),
    item(
      `blse`, 7, micro.blseList, 'Production de BLSE'
    ),
    item(
      `epc`, 8, micro.epcList,
      'Production de carbapénémase (Entérobactérales)'
    ),
    item(
      `epcType`, 9, micro.epcTypeList,
      'Type de carbapénémase (Entérobactérales)'
    ),
    item(
      `caz`, 10, resistancesIndexAndCode,
      'Résistance à la ceftazidime (CAZ)',
      go.mo.sirn
    ),
    item(
      `ppc`, 11, micro.ppcList, 'Production de carbapénémase (PSE AER)'
    ),
    item(
      `ppcType`, 12, micro.ppcTypeList, 'Type de carbapénémase (PSE AER)'
    ),
    item(
      `epcType2`, 13, micro.epcTypeList,
      'Second type de carbapénémase (Entérobactérales)'
    ),
    item(
      `ppcType2`, 14, micro.ppcTypeList,
      'Second type de carbapénémase (PSE AER)'
    )
  ]
})()

function collectResistancesInMicroOrganisms (year, mos, r) {
  assert(mos != null && mos.length !== null)
  assert.notNull(r)
  const result = []

  for (let i = 0; i !== mos.length; ++i) {
    const mo = mos[i]
    const res = mo.antibio.find(a => a.code === r.v)
    if (res == null) {
      continue
    }

    const idx = r.f == null ? res.resistance : r.f(year, res.resistance)
    const val = r.l.find(elt => elt.index === idx)
    if (val == null) {
      continue
    }

    result.push(val.code)
  }
  return result
}

export function resistanceFilterVariables (year, collect, prefix = '') {
  assert.notNull(year)
  assert.notNull(collect)

  const rlist = resistancesList
  const result = []
  for (let i = 0; i !== rlist.length; ++i) {
    const r = rlist[i]
    const k = prefix === '' ? r.n : `${prefix}_${r.n}`

    result.push(
      {
        key: k,
        name: r.t,
        field: (s) => collectResistancesInMicroOrganisms(
          year, collect(s), r
        )
      }
    )
  }
  return result
}
